<template>
  <div>
    <div v-bind:class="{ 'height-container': bg !== 'false' }">
      <nav
        v-bind:class="{ 'navbar-no-back': bg !== 'false' }"
        class="navbar navbar-expand-lg navbar-light fixed-top"
        id="mainNav"
      >
        <div class="container js-scroll-trigger">

          <!-- <a href="https://vision.ee.ethz.ch" style="display:contents">
            <div class="logo ">
              <img class="" style="height:25px; padding-right:15px" src="/cvl_biwi.png" />
            </div>
            <div class="navbar-brand ml-1" style="color:#772f80">EFCL</div>
          </a> -->

          <!--
          <button
            class="navbar-toggler navbar-toggler-right"
            type="button"
            data-toggle="collapse"
            data-target="#navbarResponsive"
            aria-controls="navbarResponsive"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          -->

          <a href="https://efcl.ethz.ch" style="display:contents">
            <div class="logo ">
              <img class="" style="height:25px; " src="/efcl_logo.svg" />
            </div>
            <!--
            <div class="navbar-brand ml-1" style="color:#772f80">EFCL</div>
            -->
          </a>
          <button
            class="navbar-toggler navbar-toggler-right"
            type="button"
            data-toggle="collapse"
            data-target="#navbarResponsive"
            aria-controls="navbarResponsive"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse" id="navbarResponsive">
            <ul class="navbar-nav mr-auto my-2 my-lg-0">
              <!-- <li class="nav-item"> -->
                <!-- <router-link to="/" class="nav-link" exact>Home</router-link> -->
              <!-- </li> -->

              <li class="nav-item">
                <router-link to="/" class="nav-link" exact
                  ><strong>MUSES</strong></router-link
                >
              </li>

              <li class="nav-item">
                <router-link to="/news" class="nav-link" exact
                  >News</router-link
                >
              </li>

              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  :class="{ 'router-link-active': subIsActive('/benchmarks') }"
                >
                  Benchmarks
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <router-link to="/benchmarks" class=" dropdown-item px-2"
                    >Overview
                  </router-link>
                  <router-link
                    to="/benchmarks#panopticSegmentation"
                    class=" dropdown-item px-2"
                    >Panoptic Segmentation
                  </router-link>
                  <router-link
                    to="/benchmarks#uncertaintyAwarePanopticSegmentation"
                    class=" dropdown-item px-2"
                    >Uncertainty-aware Panoptic Segmentation
                  </router-link>
                  <router-link
                    to="/benchmarks#semanticSegmentation"
                    class=" dropdown-item px-2"
                    >Semantic Segmentation
                  </router-link>
                  <router-link
                    to="/benchmarks#objectDetection"
                    class=" dropdown-item px-2"
                    >Object Detection
                  </router-link>
                </div>
              </li>

              <li class="nav-item">
                <router-link to="/submit" class="nav-link">Submit</router-link>
              </li>
             

              <!-- <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  :class="{ 'router-link-active': subIsActive('/materials') }"
                >
                  Materials
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <router-link
                    to="/materials#presentationSlides"
                    class=" dropdown-item px-2"
                    >Presentation Slides
                  </router-link>
                  <router-link
                    to="/materials#technicalReport"
                    class=" dropdown-item px-2"
                    >Technical Report
                  </router-link>
                </div>
              </li> -->

              
              <li class="nav-item">
                <router-link to="/download" class="nav-link"
                  >Download
                </router-link>
              </li>
             

              <!-- <li class="nav-item">
                <router-link to="/publications" class="nav-link"
                  >Publications
                </router-link>
              </li> -->
              <li class="nav-item">
                <router-link to="/citation" class="nav-link"
                  >Citation
                </router-link>
              </li>

              <li class="nav-item">
                <router-link to="/dataprotection" class="nav-link"
                  >Data Protection
                </router-link>
              </li>
              
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdownEfcl"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  :class="{ 'router-link-active': subIsActive('/efcl') }"
                >
                  EFCL
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdownEfcl">
                  <router-link to="/efcl/about" class="dropdown-item px-2"
                    >About
                  </router-link>
                  <router-link to="/efcl/announcements" class="dropdown-item px-2"
                    >Announcements
                  </router-link>
                  <router-link to="/efcl/materials" class="dropdown-item px-2"
                    >Materials
                  </router-link>
                  <router-link to="/efcl/publications" class="dropdown-item px-2"
                    >Publications
                  </router-link>
                </div>
              </li>
             

              <li class="nav-item">
                <router-link to="/contact" class="nav-link"
                  >Contact
                </router-link>
              </li>
            </ul>

            
            <ul class=" navbar-nav ml-auto my-2 my-lg-0">
              <li class="nav-item" v-if="!status || !status.loggedIn">
                <a class="nav-link" href="#" v-on:click="loginUser"
                  ><span class="fas fa-sign-in-alt"></span> Login</a
                >
              </li>
              <li
                class="dropdown nav-item"
                v-if="!(!status || !status.loggedIn)"
              >
                <a
                  href="#"
                  class="dropdown-toggle nav-link"
                  data-toggle="dropdown"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                  ><span class="fas fa-user" aria-hidden="true"></span>
                  {{ user.username }}<span class="caret"></span
                ></a>
                <ul class="dropdown-menu">
                  <li class="nav-item" v-if="user.isAdmin">
                    <router-link to="/adminPanel" class="nav-link"
                      ><span class="fas fa-columns" aria-hidden="true"></span>
                      Admin Panel</router-link
                    >
                  </li>
                  <li class="nav-item">
                    <router-link to="/submissions" class="nav-link"
                      ><span class="fas fa-list-alt" aria-hidden="true"></span>
                      Submissions</router-link
                    >
                  </li>

                  <li class="nav-item">
                    <a class="nav-link" href="#" v-on:click="logoutUser"
                      ><span
                        class="fas fa-sign-out-alt"
                        aria-hidden="true"
                      ></span>
                      Logout</a
                    >
                  </li>
                </ul>
              </li>
            </ul>
           

          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { authRequired, hasNoBackgroundNavigation } from "@/router";
import { mapActions, mapState } from "vuex";

const navbarCollapse = function() {
  if ($("#mainNav").offset().top > 100) {
    $("#mainNav").addClass("navbar-scrolled");
  } else {
    $("#mainNav").removeClass("navbar-scrolled");
  }
};

// Smooth scrolling using jQuery easing
$('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function() {
  if (
    location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") &&
    location.hostname == this.hostname
  ) {
    let target = $(this.hash);
    target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
    if (target.length) {
      $("html, body").animate(
        {
          scrollTop: target.offset().top - 72
        },
        1000,
        "easeInOutExpo"
      );
      return false;
    }
  }
});

// Closes responsive menu when a scroll trigger link is clicked
$(".js-scroll-trigger").click(function() {
  $(".navbar-collapse").collapse("hide");
});

export default {
  name: "navigation-main",
  props: ["bg"],
  computed: {
    ...mapState("api", ["status", "user"])
  },
  mounted() {
    if (this.bg === "false") {
      navbarCollapse();
      // Collapse the navbar when page is scrolled
      $(window).scroll(navbarCollapse);
    }
  },
  methods: {
    ...mapActions({
      clearAlert: "api/clear",
      cancelLogin: "api/cancel"
    }),
    ...mapActions("api", ["logout"]),
    logoutUser() {
      this.logout();
      if (authRequired(this.$router.currentRoute)) {
        this.$router.push("/");
      }
    },
    loginUser() {
      const currentPath = this.$router.currentRoute.path;
      this.$router.push("/login?target=" + currentPath);
    },
    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some(path => {
        return this.$route.path.indexOf(path) === 0; // current path starts with this path string
      });
    },
    watch: {
      $route(to, from) {
        // clear alert on location change
        this.clearAlert();
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../style/_variables.scss";

.height-container {
  height: 60px;
}

.navbar {
  -webkit-transition: padding 0.2s ease;
  -moz-transition: padding 0.2s ease;
  -o-transition: padding 0.2s ease;
  transition: padding 0.2s ease;
}

.affix {
  padding-top: 0.2em !important;
  padding-bottom: 0.2em !important;
  -webkit-transition: padding 0.2s linear;
  -moz-transition: padding 0.2s linear;
  -o-transition: padding 0.2s linear;
  transition: padding 0.2s linear;
}

.dropdown-menu {
  a {
    padding: 0.2rem 0px 0px 0.2rem;
  }
}

.dropdown-submenu {
  position: relative;
}

.dropdown-submenu a::after {
  transform: rotate(-90deg);
  position: absolute;
  right: 3px;
  top: 40%;
}

.dropdown-submenu:hover .dropdown-menu,
.dropdown-submenu:focus .dropdown-menu {
  display: flex;
  flex-direction: column;
  position: absolute !important;
  margin-top: -30px;
  left: 100%;
}

.router-link-active {
  color: $primary !important;
}

.main-content {
  padding-top: 80px;
}

#mainNav.navbar-no-back {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  background-color: #fff;
}

#mainNav.navbar-no-back .navbar-brand {
  color: #212529;
}

#mainNav.navbar-no-back .navbar-brand:hover {
  color: $primary;
}

#mainNav.navbar-no-back .navbar-nav .nav-item .nav-link {
  color: #212529;
}

#mainNav.navbar-no-back .navbar-nav .nav-item .nav-link:hover {
  color: $primary;
}
</style>
